import React, { useEffect, useState } from "react";
import "./jobs.scss";
import PreScreening from "../JobScreening/preScreening";
import TeleScreening from "../JobScreening/teleScreening";
import CandidateReportSharing from "../JobScreening/candidateReportSharing";
import VideoScreening from "../JobScreening/videoScreening";
import { fetchJobById , fetchQualifyingQuestions } from "../../Redux/ActionCreators/jobsAction";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { Alert, Snackbar } from "@mui/material";

const JobSettings = () => {
  const { jobId } = useParams();
  const dispatch = useDispatch();

  const [type, setType] = useState("");
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({open: false, message: "", severity: "success",});

  const job = useSelector((state) => state.jobs.latestJob);
  const questions = useSelector((state) => state.jobs.qualifyingQuestions || []);

  const initialfetch = async () => {
    if (jobId) {
      setLoading(true);
      await dispatch(fetchJobById(jobId));
      await dispatch(fetchQualifyingQuestions(jobId))
      setLoading(false);
    }
  };

  useEffect(() => {
    initialfetch();
  }, [jobId]);

  const hasPreScreeningStage = job?.hiring_stages?.some(
    (stage) => stage.hiring_stage_id === "3dab71cf-c680-4983-a109-1cff0953999b"
  );

  const videoStage = job?.hiring_stages?.find(
    (stage) =>
      stage.name?.toLowerCase().includes("video") ||
      stage.hiring_stage?.name?.toLowerCase().includes("video")
  );

  return (
    <div className="job-settings">
      {type === "" && (
        <div className="screening">
          {loading ? (
            <div
              className="loading-overlay"
              style={{
                position: "relative",
                marginTop: 16,
                alignItems: "start",
                height: "32px",
              }}
            >
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <>
              {hasPreScreeningStage && (
                <div className="screening-option">
                  <div>
                    <h4>Pre-Screening</h4>
                    <div style={{height:'40px'}}>
                      <p>{questions.length} questions</p>
                      <p>
                        Passing score: {" "}
                        {job?.hiring_stages?.find(
                          (stage) =>
                            stage.hiring_stage_id ===
                            "fd40e3d2-38a9-4cef-937a-93ef6a42d045"
                        )?.data?.passing_score ?? "N/A"}
                      </p>
                    </div>
                  </div>
                  <span
                    className="edit-icon"
                    onClick={() => setType("prescreening")}
                    title="Edit"
                  >
                    <img src="/images/square-pen-black.svg" alt="" />
                  </span>
                </div>
              )}
              <div className="screening-option">
                <div>
                  <h4>Telephonic Screening</h4>
                  <p style={{ height: "40px" }}>
                    {
                      job?.hiring_stages?.find(
                        (stage) => stage.hiring_stage_id === "fd40e3d2-38a9-4cef-937a-93ef6a42d045"
                      )?.data?.voice_call_name || "Mounica  Voice Assistant (US Voice)"
                    }
                  </p>
                </div>
                <span
                  className="edit-icon"
                  onClick={() => setType("telephone")}
                  title="Edit"
                >
                  <img src="/images/square-pen-black.svg" alt="" />
                </span>
              </div>
              <div className="screening-option">
                <div>
                  <h4>Candidate Report Sharing</h4>
                </div>
                  <span
                    className="edit-icon"
                    onClick={() => setType("reportSharing")}
                    title="Edit"
                    style={{marginTop: window.innerWidth < 767 ? null : '45px'}}
                  >
                    <img src="/images/square-pen-black.svg" alt="" />
                  </span>
              </div>
              <div className="screening-option">
                <div>
                  <h4>Video Interview Settings</h4>
                </div>
                  <span
                    className="edit-icon"
                    onClick={() => setType("VideoScreening")}
                    title="Edit"
                    style={{marginTop: window.innerWidth < 767 ? null : '45px'}}
                  >
                    <img src="/images/square-pen-black.svg" alt="" />
                  </span>
              </div>
            </>
          )}
        </div>
      )}
      {type === "prescreening" && <PreScreening setType={setType} />}
      {type === "telephone" && <TeleScreening setType={setType} />}
      {type === 'reportSharing' && <CandidateReportSharing setType={setType} setSnackbar={setSnackbar} />}
      {type === 'VideoScreening' && (
        <VideoScreening
          setType={setType}
          setSnackbar={setSnackbar}
          jobHiringStageId={videoStage?.id}
          hiringStageId={videoStage?.hiring_stage_id}
        />
      )}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default JobSettings;
